@if (iconSet()) {
  <div class="grid grid-cols-2 title-row mt-4">
    <div class="cols-span-7">
      <div class="table-title flex text-md lg:text-2xl">Quarterly Roll Forward
      </div>
      <div class="since-inception-text text-sm lg:text-md" data-cy="qrollTableCurrency">Since Inception |
        Expressed in
      {{portfolioSummary()?.currency}} (in millions)</div>
    </div>
    <div class="cols-span-5">
      <div class="text-right">
        @if (investmentTypes() && (investmentTypes()?.length ?? 0) > 0;) {
          <button type="button"
            (click)="exportQRollDataToCsv($event)" data-cy="exportCsv"
            class="btn export-csv-btn btn-outline-primary text-xs lg:text-md before:top-2 lg:before:top-3">
            <mat-icon fontSet="material-icons-outlined" class="export-icon">content_paste_go</mat-icon>
          Export to Excel</button>
        }
      </div>
    </div>
  </div>
  @if (!isAggregatedSeries()) {
    @if (portfolioSummary()) {
      <div class="flex flex-row qoq-title-values">
        <div class="flex-initial w-32">
          <div class="table-tvpi-value text-md lg:text-2xl"
            matTooltip="{{'Previous TVPI: ' + (summary()?.priorTvpi | tvpiValueFormat)}}&#13;{{'Current TVPI: ' + (summary()?.tvpi | tvpiValueFormat)}}"
            matTooltipClass="blue-tooltip" matTooltipPosition="below" data-cy="summaryTvpiValue">
            {{summary()?.qoQTvpiChange | tvpiValueFormat}}
          </div>
          <div class="table-tvpi-text text-sm lg:text-md">QoQ TVPI</div>
        </div>
        <div class="flex-initial w-32">
          <div class="table-irr-value text-md lg:text-2xl"
            matTooltip="{{'Previous IRR: ' + (summary()?.priorIrr | irrValueFormat)}}&#13;{{'Current IRR: ' + (summary()?.irr | irrValueFormat)}}"
            matTooltipClass="blue-tooltip" matTooltipPosition="below" data-cy="summaryIrrValue">
            {{summary()?.qoQIrrChange | irrValueFormat}}</div>
          <div class="table-irr-text text-sm lg:text-md">QoQ IRR</div>
        </div>
      </div>
    }
  }
  @if (isExpandedSeries && investmentTypes()) {
    <ng-container>
      @if (investmentTypes() && (investmentTypes()?.length ?? 0) > 0) {
        <div class="card q-roll-card bg-white" data-cy="qRollCard"
          >
          @for (investment of QRollData | sortBy:'asc' : 'priority'; track investment; let i = $index) {
            <div class="overflow-x-auto" attr.data-cy="scrollQRTable{{i}}"
              (scroll)="scrollQRTableHandler($event, investment)">
              <table class="w-full bg-white mt-6">
                <thead>
                  <tr class="mx-0 my-3 pb-14 investment-row-head align-top"
                    [ngClass]="{'border-b': !investment.isExpanded}">
                    <th class="investment-type width-18 text-left min-w-170 max-w-170 lg:max-w-full sticky-header"
                      [ngClass]="investment?.displayShadowOnQRTable ? 'shadow-background' : 'normal-background'"
                      attr.data-cy="invTypeSummary{{i}}">
                      <div class="flex">
                        {{investment.name}}
                        <app-info-icon tooltipClass="info-icon-top-5" tooltipPosition="right"
                          tooltipInfo="Totals may not sum due to rounding">
                        </app-info-icon>
                      </div>
                    </th>
                    <th class="width-14 min-w-130 max-w-130 lg:max-w-full">
                      <!-- leave room for space between name and reported values -->
                    </th>
                    <th class="text-right width-9 min-w-100 max-w-100 lg:max-w-full">
                      <div class="value text-md lg:text-xl" data-cy="qrollBalanceValue">
                        {{investment.priorNAV |
                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                      </div>
                      <div class="inv-period text-sm lg:text-md">Prior Quarter</div>
                      <div class="value-title text-sm lg:text-md">Net Asset Value</div>
                    </th>
                    <th class="text-right width-12 min-w-100 max-w-100 lg:max-w-full">
                      <div class="value text-md lg:text-xl" data-cy="qrollBalanceValue">
                        {{investment.qoQContributions |
                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                      </div>
                      <div class="inv-period text-sm lg:text-md">QOQ</div>
                      <div class="value-title text-sm lg:text-md">Contributions</div>
                    </th>
                    <th class="text-right width-12 min-w-100 max-w-100 lg:max-w-full">
                      <div class="value text-md lg:text-xl" data-cy="qrollBalanceValue">
                        {{investment.qoQDistributions |
                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                      </div>
                      <div class="inv-period text-sm lg:text-md">QOQ</div>
                      <div class="value-title text-sm lg:text-md">Distributions</div>
                    </th>
                    <th class="text-right width-12 min-w-100 max-w-100 lg:max-w-full">
                      <div class="value text-md lg:text-xl" data-cy="qrollBalanceValue">
                        {{investment.qoQGainLoss |
                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                      </div>
                      <div class="inv-period text-sm lg:text-md">QOQ</div>
                      <div class="value-title text-sm lg:text-md">Investment Gain/Loss</div>
                    </th>
                    <th class="text-right width-9 min-w-100 max-w-100 lg:max-w-full">
                      <div class="value text-md lg:text-xl" data-cy="qrollBalanceValue">{{investment.nav |
                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                      </div>
                      <div class="inv-period text-sm lg:text-md">Current Quarter</div>
                      <div class="value-title text-sm lg:text-md">Net Asset Value</div>
                    </th>
                    <th class="text-right width-7 min-w-70 max-w-70 lg:max-w-full" data-cy="tvpiChange">
                      @if(tableConfig().showSubtotalPerformance) {
                        <div class="value text-md lg:text-xl" data-cy="tvpiChangeValue">
                          {{investment.qoQTvpiChange |
                        tvpiValueFormat}}</div>
                        <div class="inv-period text-sm lg:text-md">QOQ</div>
                        <div class="value-title text-sm lg:text-md">TVPI</div>
                      }
                    </th>
                    <th class="text-right width-7 min-w-70 max-w-70 lg:max-w-full" data-cy="invIrrChange">
                      @if(tableConfig().showSubtotalPerformance) {
                        <div class="value text-md lg:text-xl" data-cy="invIrrChangeValue">
                          {{investment.qoQIrrChange |
                        irrValueFormat}}</div>
                        <div class="inv-period text-sm lg:text-md">QOQ</div>
                        <div class="value-title text-sm lg:text-md">IRR</div>
                      }
                    </th>
                  </tr>
                  <!-- Investment type expand/collapse icon -->
                  <img class="expand-collapse-icon-series mb-[-9px]" attr.data-cy="invTypeIcon{{i}}"
                    (click)="expandTable(investment)"
                    (keydown.enter)="expandTable(investment)"
                    (keydown.space)="expandTable(investment)"
                    [attr.alt]="investment.isExpanded ? 'Collapse ' + investment.name : 'Expand ' + investment.name"
                    tabindex="0"
                    role="button"
                    src="{{ investment.isExpanded ? iconSet()?.['icon.series.collapse'] : iconSet()?.['icon.expand']}}">
                  </thead>
                </table>
                @if (investment.isExpanded) {
                  <div class="investment-type-table">
                    <table mat-table matSort [dataSource]="dataSources[investment.priority - 1]"
                      class="mb-3 investment-type-section bg-white" multiTemplateDataRows
                      attr.data-cy="invTypeExpandedView{{i}}">
                      <!-- Beginning Column and Td cell Section -->
                      <!-- Name Column -->
                      <ng-container matColumnDef="name" sticky>
                        <th mat-header-cell mat-sort-header *matHeaderCellDef [attr.rowspan]="2"
                          [ngClass]="investment?.displayShadowOnQRTable ? 'shadow-background' : 'normal-background'"
                          class="width-18 text-left sub-header text-sm lg:text-md min-w-170 max-w-170 lg:max-w-full border border-l-0">
                        Deal Name </th>
                        <td mat-cell *matCellDef="let deal"
                          class="width-18 text-left deal-row text-sm lg:text-md"
                          [ngClass]="{'deal-name': !deal.disableDrillThrough, 'shadow-background': investment?.displayShadowOnQRTable, 'normal-background': !investment?.displayShadowOnQRTable}">
                          <div class="deal-name-div" data-cy="dealNameQRoll">
                            @if (!deal.disableDrillThrough) {
                              <a
                                routerLinkActive="active"
                                [routerLink]=" ['/investor', investorId(), 'series' , seriesId(), 'deal' , deal.masterId]"
                                [queryParams]="{'reportingdate':reportingPeriod()}"
                                (click)="activityTracking.navigateToDashboard('Deal', deal, 'series qroll table')">
                                {{deal.name}}
                              </a>
                            }
                            @if (deal.disableDrillThrough) {
                              <span data-cy="dealNameDisabled">
                                {{deal.name}}
                              </span>
                            }
                            <img class="expand-collapse-icon-holding"
                              [ngClass]="{'hidden': !deal.showHoldings}"
                              [attr.alt]="deal.isExpanded ? 'Collapse ' + deal.name : 'Expand ' + deal.name"
                              tabindex="0"
                              role="button"
                              (click)="deal.isExpanded = !deal.isExpanded; activityTracking.expandOrCollapseToggled('deal', deal, 'series qroll table', deal.isExpanded)"
                              (keydown.enter)="deal.isExpanded = !deal.isExpanded; activityTracking.expandOrCollapseToggled('deal', deal, 'series qroll table', deal.isExpanded)"
                              (keydown.space)="deal.isExpanded = !deal.isExpanded; activityTracking.expandOrCollapseToggled('deal', deal, 'series qroll table', deal.isExpanded)"
                              src="{{ deal.isExpanded ? iconSet()?.['icon.series.collapse'] : iconSet()?.['icon.expand']}}">
                            </div>
                          </td>
                        </ng-container>
                        <!-- Investment Status Column -->
                        <ng-container matColumnDef="realizationType">
                          <th mat-header-cell mat-sort-header *matHeaderCellDef [attr.rowspan]="2"
                            class="border border-l-0 pl-2 text-left sub-header width-14 text-sm lg:text-md min-w-130 max-w-130 lg:max-w-full">
                          Investment Status </th>
                          <td mat-cell *matCellDef="let deal" data-cy="qrollDealInvestmentStatus"
                            class="border-right pl-2 text-left deal-row width-14 text-sm lg:text-md">
                            {{deal.realizationType}}
                          </td>
                        </ng-container>
                        <!-- Prior Quarter Net Asset Value Column -->
                        <ng-container matColumnDef="priorNAV">
                          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef [attr.rowspan]="2"
                            class="border border-l-0 text-right width-9 sub-header text-sm lg:text-md min-w-100 max-w-100 lg:max-w-full">
                          Prior Quarter NAV </th>
                          <td mat-cell *matCellDef="let deal"
                            class="border-right text-right width-9 deal-row text-sm lg:text-md"
                            data-cy="qrollDealBalanceValue">
                            {{deal.priorNAV |
                            currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                          </td>
                        </ng-container>
                        <!-- Contributions Column -->
                        <ng-container matColumnDef="qoQContributions">
                          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                            class="text-right width-12 sub-header text-sm lg:text-md min-w-100 max-w-100 lg:max-w-full pr-0 lg:pr-1">
                          Contributions </th>
                          <td mat-cell *matCellDef="let deal"
                            class="text-right width-12 deal-row text-sm lg:text-md"
                            data-cy="qrollDealBalanceValue">
                            {{deal.qoQContributions |
                          currencyFormat:portfolioSummary()?.currency:'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Distributions Column -->
                        <ng-container matColumnDef="qoQDistributions">
                          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                            class="text-right width-12 sub-header text-sm lg:text-md min-w-100 max-w-100 lg:max-w-full">
                          Distributions </th>
                          <td mat-cell *matCellDef="let deal"
                            class="text-right width-12 deal-row text-sm lg:text-md"
                            data-cy="qrollDealBalanceValue">
                            {{deal.qoQDistributions |
                          currencyFormat:portfolioSummary()?.currency:'Millions':true:true}} </td>
                        </ng-container>
                        <!-- qoQGainLoss Column -->
                        <ng-container matColumnDef="qoQGainLoss">
                          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                            class="border-right text-right width-12 sub-header text-sm lg:text-md min-w-100 max-w-100 lg:max-w-full">
                          Investment Gain/Loss </th>
                          <td mat-cell *matCellDef="let deal"
                            class="border-right text-right width-12 deal-row text-sm lg:text-md"
                            data-cy="qrollDealBalanceValue">
                            {{deal.qoQGainLoss |
                          currencyFormat:portfolioSummary()?.currency:'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Current Quarter Net Asset Value Column -->
                        <ng-container matColumnDef="nav">
                          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef [attr.rowspan]="2"
                            class="border text-right width-9 sub-header text-sm lg:text-md min-w-100 max-w-100 lg:max-w-full">
                          Current Quarter NAV </th>
                          <td mat-cell *matCellDef="let deal"
                            class="border-right text-right width-9 deal-row text-sm lg:text-md"
                            data-cy="qrollDealBalanceValue"> {{deal.nav |
                          currencyFormat:portfolioSummary()?.currency:'Millions':true:true}} </td>
                        </ng-container>
                        <!-- TVPI Column -->
                        <ng-container matColumnDef="qoQTvpiChange">
                          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                            class="text-right width-7 sub-header text-sm lg:text-md min-w-70 max-w-70 lg:max-w-full">
                            &Delta; TVPI
                          </th>
                          <td mat-cell *matCellDef="let deal"
                            class="text-right width-7 deal-row text-sm lg:text-md" data-cy="dealTvpiChange">
                            {{deal.qoQTvpiChange |
                          tvpiValueFormat}} </td>
                        </ng-container>
                        <!-- IRR Column -->
                        <ng-container matColumnDef="qoQIrrChange">
                          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                            class="text-right width-7 sub-header text-sm lg:text-md min-w-70 max-w-70 lg:max-w-full">
                            &Delta; IRR
                          </th>
                          <td mat-cell *matCellDef="let deal"
                            class="text-right width-7 deal-row text-sm lg:text-md" data-cy="dealIrrChange">
                            {{deal.qoQIrrChange | irrValueFormat}} 
                          </td>
                        </ng-container>
                        <!-- Ending Column and Td cell Section -->
                        <!-- Header row QoQ section -->
                        <ng-container matColumnDef="header-row-qoq-change">
                          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3"
                          class="width-36 header-cell border border-x-0 min-w-300"> QoQ Change</th>
                        </ng-container>
                        <!-- Header row QoQ change performance section -->
                        <ng-container matColumnDef="header-row-qoq-change-performance">
                          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"
                          class="width-14 header-cell border border-x-0 min-w-140 "> QoQ Change</th>
                        </ng-container>
                        <!-- Beginning Expanded Rows -->
                        <ng-container matColumnDef="expandedDetail">
                          <td *matCellDef="let deal" [attr.colspan]="12" class="p-0">
                              @if (deal.isExpanded) {
                                <div animate.enter="detail-expand-enter" animate.leave="detail-expand-leave">
                                  <table mat-table [dataSource]="deal.holdings" class="qroll-table">
                                    <!-- Name Column -->
                                    <ng-container matColumnDef="holdingName" sticky>
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        [ngClass]="{'shadow-background':deal.investmentType?.displayShadowOnTable, 'normal-background':!deal.investmentType?.displayShadowOnTable, 'border-top-0': first}"
                                        class="min-w-170 max-w-170 lg:max-w-full width-18 text-left holding-row text-sm lg:text-md">
                                        <span
                                          data-cy="holdingsRedirectLinkDisabled">
                                          {{holding.name}}
                                        </span>
                                      </td>
                                    </ng-container>
                                    <!-- Investment Status Column -->
                                    <ng-container matColumnDef="realizationType">
                                      <td mat-cell data-cy="qrollHoldingInvestmentStatus"
                                        *matCellDef="let holding; let i = index; let first = first"
                                        class="border-right text-left holding-row width-14 text-sm lg:text-md min-w-130 max-w-130 lg:max-w-full">
                                        {{holding.status}}
                                      </td>
                                    </ng-container>
                                    <!-- Prior Quarter Net Asset Value Column -->
                                    <ng-container matColumnDef="holdingPriorNAV">
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        class="border-right text-right width-9 holding-row min-w-100 text-sm lg:text-md"
                                        [ngClass]="{'border-top-0': first}"
                                        data-cy="qrollHoldingBalanceValue">
                                        {{holding.priorNAV |
                                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                                      </td>
                                    </ng-container>
                                    <!-- Contributions Column -->
                                    <ng-container matColumnDef="holdingQoQContributions">
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        [ngClass]="{'border-top-0': first}"
                                        class="text-right width-12 holding-row min-w-100 text-sm lg:text-md"
                                        data-cy="qrollHoldingBalanceValue">
                                        {{holding.qoQContributions |
                                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                                      </td>
                                    </ng-container>
                                    <!-- Distributions Column -->
                                    <ng-container matColumnDef="holdingQoQDistributions">
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        [ngClass]="{'border-top-0': first}"
                                        class="text-right width-12 holding-row min-w-100 text-sm lg:text-md"
                                        data-cy="qrollHoldingBalanceValue">
                                        {{holding.qoQDistributions |
                                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                                      </td>
                                    </ng-container>
                                    <!-- qoQGainLoss Column -->
                                    <ng-container matColumnDef="holdingQoQGainLoss">
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        [ngClass]="{'border-top-0': first}"
                                        class="border-right text-right width-12 holding-row min-w-100 text-sm lg:text-md"
                                        data-cy="qrollHoldingBalanceValue">
                                        {{holding.qoQGainLoss |
                                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                                      </td>
                                    </ng-container>
                                    <!-- Current Quarter Net Asset Value Column -->
                                    <ng-container matColumnDef="holdingNav">
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        [ngClass]="{'border-top-0': first}"
                                        class="border-right text-right width-9 holding-row min-w-100 text-sm lg:text-md"
                                        data-cy="qrollHoldingBalanceValue"> {{holding.nav |
                                        currencyFormat:portfolioSummary()?.currency:'Millions':true:true}}
                                      </td>
                                    </ng-container>
                                    <!-- TVPI Column -->
                                    <ng-container matColumnDef="holdingQoQTvpiChange">
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        [ngClass]="{'border-top-0': first}"
                                        class="text-right width-7 holding-row min-w-70 text-sm lg:text-md"
                                        data-cy="holdingTvpiChange"></td>
                                    </ng-container>
                                    <!-- IRR Column -->
                                    <ng-container matColumnDef="holdingQoQIrrChange">
                                      <td mat-cell
                                        *matCellDef="let holding; let i = index; let first = first"
                                        [ngClass]="{'border-top-0': first}"
                                        class="text-right width-7 holding-row min-w-70 text-sm lg:text-md"
                                        data-cy="holdingIrrChange"></td>
                                    </ng-container>
                                    <tr mat-row
                                      *matRowDef="let holding; columns: innerDisplayedColumns;"
                                      attr.data-cy="qrollHoldingRow{{holding.masterId}}">
                                    </tr>
                                  </table>
                                </div>
                              }
                          </td>
                        </ng-container>
                        <!-- Ending Expanded Rows -->
                        <tr mat-header-row
                          *matHeaderRowDef="['name', 'realizationType', 'priorNAV', 'header-row-qoq-change', 'nav', 'header-row-qoq-change-performance']; sticky: true">
                        </tr>
                        <tr mat-header-row *matHeaderRowDef="headerColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let deal; columns: displayedColumns;"
                          tourAnchor="series.dashboard.qroll" attr.data-cy="qrollDealRow{{deal.masterId}}">
                        </tr>
                        <tr mat-row *matRowDef="let deal; columns: ['expandedDetail']"
                        [ngClass]="{'hidden': !deal.isExpanded}"></tr>
                      </table>
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="w-full series-table-error" data-cy="noResults">
              <div class="row">
                <div class="col-12">
                  <div class=" mt-3">
                    <div>
                      <p class="text-center error-message">No Results</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </ng-container>
      }
    }